export const ScrapeTemplateFragment = gql`
  fragment ScrapeTemplateFragment on ScrapeTemplate {
    id
    startUrl
    excludeUrlGlobs
    mostRecentScrape {
      ...ScrapeFragment
    }
  }
`
